import request from "@utils/request";

export function getDataLargeVolume(query) {
    return request({
        url: 'alert/data/large-volume',
        method: 'get',
        params: query
    })
}
